export default __webpack_public_path__ + "static/media/Icon-white.b356c177.svg";